import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import {
  ConnectivityService,
  ConnectionStrength
} from '../../services/connectivity.service';

@Component({
  selector: 'app-connection-strength-indicator',
  standalone: true,
  imports: [MatTooltipModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './connection-strength-indicator.component.html'
})
export class ConnectionStrengthIndicatorComponent {
  private readonly connectivity = inject(ConnectivityService);

  readonly strength = this.connectivity.strength;
  readonly label = this.connectivity.strengthLabel;
  readonly downlink = this.connectivity.downlink;
  readonly rtt = this.connectivity.rtt;

  /** The four bars, shortest first. */
  readonly barHeights = [4, 7, 10, 12];

  get tooltipText(): string {
    const s = this.strength();
    if (s === 'offline') return 'You are offline';

    const dl = this.downlink();
    const rt = this.rtt();
    let tip = `Connection: ${this.label()}`;
    if (dl !== null) tip += ` · ${dl} Mbps`;
    if (rt !== null) tip += ` · ${rt}ms`;
    return tip;
  }

  activeBars(strength: ConnectionStrength): number {
    switch (strength) {
      case 'excellent':
        return 4;
      case 'good':
        return 3;
      case 'fair':
        return 2;
      case 'poor':
        return 1;
      case 'offline':
        return 0;
    }
  }

  barColor(strength: ConnectionStrength): string {
    switch (strength) {
      case 'excellent':
        return '#22c55e';
      case 'good':
        return '#22c55e';
      case 'fair':
        return '#f59e0b';
      case 'poor':
        return '#ef4444';
      case 'offline':
        return '#9ca3af';
    }
  }
}
